import {
	Action,
	AnyAction,
	ThunkAction,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit';

import vehicleServiceSlice from './slices/vehicleServiceSlice';

const reducers = {
	vehicleService: vehicleServiceSlice,
};

const rootReducer = combineReducers(reducers);

const combinedRootReducer = (
	state: ReturnType<typeof rootReducer> | undefined,
	action: AnyAction,
) => {
	if (action.type === 'resetStore') {
		return rootReducer(undefined, action);
	}
	return rootReducer(state, action);
};

export const store = configureStore({
	reducer: combinedRootReducer,
	devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
